import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleCustomize = () => {
    localStorage.setItem('cookieConsent', 'customized');
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>We Value Your Privacy</h3>
          <p>
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
            Cookies help us understand how you interact with our website and improve our services.
          </p>
          <p>
            By clicking Accept All, you consent to our use of cookies for analytics and personalization. 
            You can customize your preferences or decline non-essential cookies. 
            Learn more in our <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAcceptAll} className="cookie-btn accept-all">
            Accept All
          </button>
          <button onClick={handleDecline} className="cookie-btn decline">
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;